import React, { useState, useContext, useEffect } from "react";
import { Segment, Grid, Container, Form, Button,  } from "semantic-ui-react";
import { Form as FinalForm, Field } from "react-final-form";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";

import LoadingComponent from "../../../app/layout/LoadingComponent";
import { RootStoreContext } from "../../../app/stores/rootStore";
import SelectInputOnChange from "../../../app/common/form/SelectInputOnChange";

import { getYearOptions, getMonthOptions, getClientOptions, exportReport, validateForm } from "./helpers";


const TenantReportExportForm: React.FC = () => {
  const [formInputValues, setFormInputValues] = useState({
    client: "",
    yearReports: "",
    startMonthReports: "",
  });

  const rootStore = useContext(RootStoreContext);
  const { getClients, loadClients, clients } = rootStore.clienStore;
  const { getDetailedReportTenantByRangeDate } = rootStore.reportStore;
  const { loading, changeState } = rootStore.buttonLoadingStore;

  useEffect(() => {
    getClients();
  }, [getClients]);

  const handleFormInputChanges = (input, value) => {
    setFormInputValues((current) => ({
      ...current,
      [input.name]: value,
    }));
  };

  const handleRequestReports = (value) => {
    const [tenantId, tenantCompanyId] = value.client.split("%");

    const body = {
      dateFrom: `${value.startMonthReports}-${value.yearReports}`,
      dateTo: `${value.endMonthReports}-${value.yearReports}`,
      tenantId,
    };

    const reportInfo = {
      year: value.yearReports,
      monthFrom: value.startMonthReports,
      monthTo: value.endMonthReports,
      tenantCompanyId,
    };

    getDetailedReportTenantByRangeDate(body)
      .then((report) => {
        const separateLines = report.split(/\r?\n|\r|\n/g);

        const hasReports = separateLines.length > 1 && separateLines[1].trim().length > 0;
        if (!hasReports) {
          throw new Error('No se encontraron reportes para el rango de fechas seleccionado');
        }

        exportReport(report, reportInfo);
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        changeState();
      });
  };

  if (!loadClients) {
    return (
      <Segment>
        <LoadingComponent content="Cargando" />
      </Segment>
    );
  }

  const isYearInputEnabled = formInputValues.client;
  const isMonthFromInputEnabled = formInputValues.yearReports
  const isMonthToInputEnabled = formInputValues.startMonthReports

  return (
    <Segment>
      <Container textAlign="left">
        <h2>Seleccione las opciones del reporte</h2>
        <FinalForm
          validate={validateForm}
          initialValues={formInputValues}
          onSubmit={handleRequestReports}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="filter">
                <Grid relaxed doubling>
                  <Grid.Row>
                    <Grid.Column>
                      <label>Cliente:</label>
                      <Field
                        name="client"
                        component={SelectInputOnChange}
                        placeholder="Seleccione un cliente"
                        options={getClientOptions(clients)}
                        onChange={handleFormInputChanges}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      <label className={`${isYearInputEnabled ? '' : 'disabled-label'}`}>
                        Año:
                      </label>
                      <Field
                        name="yearReports"
                        disabled={!isYearInputEnabled}
                        component={SelectInputOnChange}
                        placeholder="Seleccionar año"
                        options={getYearOptions()}
                        onChange={handleFormInputChanges}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <label className={`${isMonthFromInputEnabled ? '' : 'disabled-label'}`}>
                        Mes desde:
                      </label>
                      <Field
                        name="startMonthReports"
                        disabled={!isMonthFromInputEnabled}
                        component={SelectInputOnChange}
                        placeholder="Seleccione un mes"
                        options={getMonthOptions(isMonthFromInputEnabled, formInputValues.yearReports)}
                        onChange={handleFormInputChanges}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <label className={`${isMonthToInputEnabled ? '' : 'disabled-label'}`}>
                        Mes hasta:
                      </label>
                      <Field
                        name="endMonthReports"
                        disabled={!isMonthToInputEnabled}
                        component={SelectInputOnChange}
                        placeholder="Seleccione un mes"
                        options={getMonthOptions(isMonthFromInputEnabled, formInputValues.yearReports, formInputValues.startMonthReports)}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <br />
                <Button
                  loading={loading}
                  className="ui primary button filterbutton"
                  color="blue"
                  type="submit"
                  content="Exportar reporte"
                />
              </div>
            </Form>
          )}
        />
      </Container>
    </Segment>
  );
};

export default observer(TenantReportExportForm);
